import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import Layout from 'components/Layout'
import MainContentContainer from 'components/MainContentContainer'
import Loading from 'components/Loading'
import CustomBreadcrumb from 'components/CustomBreadcrumb'
import { contentfulDefaultOptions } from 'services/contentful'
import { useBreadcrumb, useServicesAndWills } from 'hooks/resources'
import { WhiteArrowDown } from 'assets/images'

import { DropDownWrapper, StyledItemWrapper, DropdownTile, DropdownTileContent } from './ServicesAndWills.styles'

const ServicesAndWills = () => {
  const { data, displayLoading, handleClick } = useServicesAndWills()
  const { breadcrumbItems, handleBreadcrumbTabChange } = useBreadcrumb()

  return (
    <Layout>
      <MainContentContainer pageName="Lasting Power of Attorney Services">
        <CustomBreadcrumb breadcrumbItems={breadcrumbItems} handleBreadcrumbTabChange={handleBreadcrumbTabChange} />
        <DropDownWrapper>
          {displayLoading ? (
            <Loading />
          ) : (
            <>
              {data.map((item) => (
                <StyledItemWrapper key={item.id}>
                  <DropdownTile onClick={() => handleClick(item.id)}>
                    <p>{item.title}</p>
                    <img src={WhiteArrowDown} alt="" width={33} height={25} />
                  </DropdownTile>
                  {item.isShown && <DropdownTileContent>{documentToReactComponents(item.content, contentfulDefaultOptions)}</DropdownTileContent>}
                </StyledItemWrapper>
              ))}
            </>
          )}
        </DropDownWrapper>
      </MainContentContainer>
    </Layout>
  )
}

export default ServicesAndWills
